import React from 'react'
import { AdjustmentProvider } from './Context'
import { AdjustmentForm } from './AdjustmentForm'
import type { AdjustmentProps } from '@ztechapps/webui.contract'

export const Adjustment = (props: AdjustmentProps) => {
  return (
    <AdjustmentProvider {...props}>
      <AdjustmentForm />
    </AdjustmentProvider>
  )
}
